import { render, staticRenderFns } from "./OldTasks.vue?vue&type=template&id=35a95285&scoped=true&"
import script from "./OldTasks.vue?vue&type=script&lang=js&"
export * from "./OldTasks.vue?vue&type=script&lang=js&"
import style0 from "./OldTasks.vue?vue&type=style&index=0&id=35a95285&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a95285",
  null
  
)

export default component.exports